export default "__VITE_ASSET__CNHbkk6b__"